import React from 'react';

interface AaveLogoProps {
    width?: number;
}

const AaveLogo: React.FC<AaveLogoProps> = ({ width = 60 }) => (
    <svg
        id="Layer_1"
        width={width}
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 400 700"
    >
        <defs>
            <linearGradient
                id="linear-gradient"
                x1="-704.19"
                y1="767.94"
                x2="-697.34"
                y2="769.54"
                gradientTransform="matrix(55.73 0 0 -61.13 39255.9 47634.81)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#31bac6" />
                <stop offset="1" stopColor="#b6509e" />
            </linearGradient>
            <linearGradient
                id="linear-gradient-2"
                x1="-701.88"
                y1="767.38"
                x2="-692.83"
                y2="769"
                gradientTransform="matrix(42.21 0 0 -60.24 29648.47 46951.49)"
                xlinkHref="#linear-gradient"
            />
            <linearGradient
                id="linear-gradient-3"
                x1="-703.35"
                y1="768.13"
                x2="-696.51"
                y2="769.72"
                gradientTransform="matrix(55.78 0 0 -61.13 39241.29 47638.69)"
                xlinkHref="#linear-gradient"
            />
            <linearGradient
                id="linear-gradient-4"
                x1="-702.33"
                y1="768.56"
                x2="-695.49"
                y2="770.16"
                gradientTransform="matrix(55.78 0 0 -61.13 39181.2 47635.57)"
                xlinkHref="#linear-gradient"
            />
            <linearGradient
                id="linear-gradient-5"
                x1="-702.24"
                y1="771.51"
                x2="-694.84"
                y2="776.58"
                gradientTransform="matrix(54.82 0 0 -80.09 38491.14 62326)"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stopColor="#30bac6" />
                <stop offset="1" stopColor="#b6509e" />
            </linearGradient>
        </defs>
        <g id="Group_4051" data-name="Group 4051">
            <path
                id="Path_2431"
                data-name="Path 2431"
                d="M243.75 683.31l-36.86-89.38a7.9 7.9 0 01-.45-2.54 7 7 0 011.81-5 6.35 6.35 0 014.89-1.9 6.63 6.63 0 013.8 1.26 8.11 8.11 0 012.63 3.36l35 87.48 35.05-87.48a8.08 8.08 0 012.62-3.36 6.68 6.68 0 013.81-1.26 6.35 6.35 0 014.89 1.9 7 7 0 011.81 5 7.79 7.79 0 01-.45 2.53l-36.86 89.39c-2.08 4.62-5.16 6.89-9.24 6.89H253c-4.09 0-7.17-2.27-9.25-6.89z"
                fill="url(#linear-gradient)"
            />
            <path
                id="Path_2432"
                data-name="Path 2432"
                d="M318.46 687.48a6.54 6.54 0 01-1.91-4.8v-90.57a6.92 6.92 0 011.91-4.89 6.27 6.27 0 014.79-2h59.86a6 6 0 014.53 1.9 6.1 6.1 0 011.9 4.53 5.76 5.76 0 01-1.9 4.44 6.38 6.38 0 01-4.53 1.81h-53v33h47.63a6 6 0 014.52 1.91 6.22 6.22 0 011.91 4.52 5.77 5.77 0 01-1.91 4.44 6.34 6.34 0 01-4.52 1.81h-47.6v33.15h53a5.91 5.91 0 014.53 1.9 6.09 6.09 0 011.9 4.53 5.77 5.77 0 01-1.9 4.44 6.38 6.38 0 01-4.53 1.81h-59.89a5.91 5.91 0 01-4.79-1.93z"
                fill="url(#linear-gradient-2)"
            />
            <path
                id="Path_2433"
                data-name="Path 2433"
                d="M215.22 680.78l-36.85-89.39c-2.07-4.62-5.16-6.88-9.24-6.88h-3.26c-4.08 0-7.16 2.26-9.24 6.88l-16 38.94h-12.16a6.65 6.65 0 00-6.61 6.61v.06a6.65 6.65 0 006.61 6.61H135l-15.3 37.13a7.91 7.91 0 00-.46 2.54 7 7 0 001.81 5 6.36 6.36 0 004.89 1.9 6.61 6.61 0 003.81-1.26 8.11 8.11 0 002.63-3.36l16.84-41.92h11.58a6.65 6.65 0 006.6-6.64v-.18a6.65 6.65 0 00-6.61-6.61h-6.25l13-32.15 35 87.49a8.08 8.08 0 002.63 3.35 6.64 6.64 0 003.8 1.27 6.35 6.35 0 004.89-1.91 7 7 0 001.81-5 6 6 0 00-.45-2.48z"
                fill="url(#linear-gradient-3)"
            />
            <path
                id="Path_2434"
                data-name="Path 2434"
                d="M105.11 680.78l-36.86-89.39c-2.08-4.62-5.16-6.88-9.24-6.88h-3.26c-4.07 0-7.15 2.26-9.23 6.88l-16 38.94H18.35a6.65 6.65 0 00-6.61 6.61v.06a6.65 6.65 0 006.61 6.62h6.52l-15.3 37.16a7.79 7.79 0 00-.45 2.53 7 7 0 001.81 5 6.35 6.35 0 004.89 1.9 6.59 6.59 0 003.8-1.27 8.08 8.08 0 002.63-3.35l16.84-41.93h11.68a6.65 6.65 0 006.61-6.66v-.18a6.65 6.65 0 00-6.61-6.61h-6.25l12.86-32.16 35.05 87.49a8.08 8.08 0 002.63 3.35 6.57 6.57 0 003.8 1.27 6.35 6.35 0 004.89-1.91 7 7 0 001.81-5 5.94 5.94 0 00-.45-2.47z"
                fill="url(#linear-gradient-4)"
            />
        </g>
        <g id="Group_13465" data-name="Group 13465">
            <path
                id="Path_7142"
                data-name="Path 7142"
                d="M389.41 193.54c-2-105-88.73-188.45-193.71-186.44A190.1 190.1 0 009.26 193.54c0 .47-.06 1-.06 1.45v346.62a21.13 21.13 0 1042.26 0v-61.42a21.13 21.13 0 1142.26 0v29.14a21.14 21.14 0 0042.27 0v-29.14a21.13 21.13 0 0121.12-21.13 21.14 21.14 0 0121.13 21.13v8a21.13 21.13 0 0042.26 0v-8a21.14 21.14 0 0142.27 0v29.14a21.13 21.13 0 1042.26 0v-29.14a21.13 21.13 0 0121.12-21.13 21.14 21.14 0 0121.13 21.13v61.42a21.13 21.13 0 1042.26 0V195c-.06-.5-.09-1-.13-1.46zM129.22 224c-18.68 0-33.83-17.34-33.83-38.79s15.15-38.79 33.83-38.79 33.83 17.34 33.83 38.79S147.93 224 129.24 224zm71.62 54.75c-17 0-30.7-10.1-30.7-22.57s13.75-4.94 30.7-4.94 30.7-7.52 30.7 4.94-13.71 22.56-30.68 22.56zM269.45 224c-18.68 0-33.83-17.34-33.83-38.79s15.15-38.79 33.83-38.79 33.83 17.34 33.83 38.79S288.14 224 269.46 224z"
                fill="url(#linear-gradient-5)"
            />
            <g id="Group_13464" data-name="Group 13464">
                <ellipse
                    id="Ellipse_598"
                    data-name="Ellipse 598"
                    style={{ fill: 'none' }}
                    cx="129.24"
                    cy="185.18"
                    rx="33.83"
                    ry="38.79"
                />
                <path
                    id="Path_7143"
                    data-name="Path 7143"
                    style={{ fill: 'none' }}
                    d="M200.86 251.2c-17 0-30.7-7.52-30.7 4.94s13.75 22.56 30.7 22.56 30.7-10.1 30.7-22.56-13.73-4.94-30.7-4.94z"
                />
                <ellipse
                    id="Ellipse_599"
                    data-name="Ellipse 599"
                    style={{ fill: 'none' }}
                    cx="269.47"
                    cy="185.18"
                    rx="33.83"
                    ry="38.79"
                />
            </g>
            <path
                id="Path_7146"
                data-name="Path 7146"
                d="M12.05 165.07S48.83 48.27 201.42 49.4c189.37 2.29 188 214.4 188 214.4s17.08-148.69-71.73-214.66-164-36.7-198.43-23.76-99.8 67.83-107.21 139.69z"
                style={{ isolation: 'isolate' }}
                opacity=".06"
                fill="#fff"
            />
            <path
                id="Path_7147"
                data-name="Path 7147"
                d="M36.23 100.19S98 33 183.6 32.11 329.18 59.28 357.38 117a374.42 374.42 0 0132.1 125s17.08-126.87-71.73-192.82S153.8 12.46 119.31 25.4s-58.79 41.52-83.08 74.79z"
                style={{ isolation: 'isolate' }}
                opacity=".15"
                fill="#fff"
            />
            <path
                id="Path_7148"
                data-name="Path 7148"
                style={{ isolation: 'isolate', opacity: '.21' }}
                d="M95.4 185.18s2.38-41.48 33.84-41.53 33.83 41.53 33.83 41.53-6.56-38.79-33.83-38.79c-19.48.03-34.7 30.04-33.84 38.79z"
            />
            <path
                id="Path_7149"
                data-name="Path 7149"
                style={{ isolation: 'isolate', opacity: '.21' }}
                d="M235.65 185.18s2.38-41.48 33.83-41.53 33.83 41.53 33.83 41.53-6.55-38.79-33.83-38.79c-19.48.03-34.72 30.04-33.83 38.79z"
            />
            <path
                id="Path_7150"
                data-name="Path 7150"
                style={{ isolation: 'isolate', opacity: '.1' }}
                d="M129.24 138.61c-15 0-38.24 16.84-38.24 46.56a41.06 41.06 0 0038.24 42.94c14.5 0 36.43-13.18 36.43-42.94s-21.44-46.56-36.43-46.56zm.51 84.72c-21.22.67-33.81-23.09-33.81-40.33a34.07 34.07 0 0133.21-34.91h.6c21.06 0 30.17 17.64 30.17 34.92s-8.92 39.7-30.17 40.32z"
            />
            <path
                id="Path_7151"
                data-name="Path 7151"
                style={{ isolation: 'isolate', opacity: '.1' }}
                d="M270.7 138.61c-15 0-38.25 16.84-38.25 46.56a41.07 41.07 0 0038.25 42.94c14.5 0 36.42-13.18 36.42-42.94s-21.44-46.56-36.42-46.56zm.5 84.72c-21.2.67-33.81-23.09-33.81-40.33a34.08 34.08 0 0133.22-34.91h.59c21.06 0 30.18 17.64 30.18 34.92s-8.95 39.7-30.18 40.32z"
            />
            <path
                id="Path_7152"
                data-name="Path 7152"
                style={{ isolation: 'isolate', opacity: '.1' }}
                d="M170.79 260.71s5.07 18 30.49 18c22.08-.5 28.56-14.57 29.37-16.5A28 28 0 01201.44 287a29.61 29.61 0 01-30.65-26.29z"
            />
            <g opacity=".3">
                <path
                    style={{ fill: '#fff' }}
                    d="M372.28 313.18a3 3 0 00-3 3v91.14a3 3 0 006 0v-91.15a3 3 0 00-3-2.99zM372.28 266a3 3 0 00-3 3v18.45a3 3 0 006 0V269a3 3 0 00-3-3zM26.83 242.87a3 3 0 00-3 3v54.79a3 3 0 106 0v-54.8a3 3 0 00-3-2.99z"
                />
            </g>
        </g>
    </svg>
);

export default AaveLogo;
